<template>
    <div class="FieldHelpWrap WysiwygWrap">
        <div class="FieldHelpWrap__input">
            <SWysiwyg
                :name="name"
                :input-data="text"
                :namespace="fieldNamespace"
                :key="fieldNamespace"
            />
        </div>
        <div
            class="FieldHelpWrap__help"
            v-if="helpText"
        >
            <HelpModal
                v-if="helpText"
                :text="helpText"
                :title="helpTitle"
            />
        </div>
    </div>
</template>

<script>
import SubmissionBoilerplate from '@/views/Public/Field/Fields/SubmissionBoilerplate';

import SWysiwyg from '@/views/Common/Input/SWysiwyg';

export default {
    components: {
        SWysiwyg,
    },
    mixins: [ SubmissionBoilerplate ],

    data() {
        return {
            text: '',
        };
    },

    methods: {
        loadFieldData() {
            if (this.submission && this.submission.text) {
                this.text = this.submission.text;
            } else if (this.population && this.population.text) {
                this.text = this.population.text;
            }
            this.setFieldData();
        },

        setFieldData() {
            this.fieldData = {
                text: this.text
            };

            this.storeFieldData();
        }
    }
};
</script>
